import { enableProdMode, ApplicationRef } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { devTools } from '@ngneat/elf-devtools';
import { KickfloFrontendModule } from './app/kickflo-frontend.module';

if (process.env.NG_APP_PRODUCTION === 'true') {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(KickfloFrontendModule)
  .then((moduleRef) => {
    devTools({
      postTimelineUpdate: () => moduleRef.injector.get(ApplicationRef).tick(),
    });
  })
  .catch((err) => console.error(err));
